import React from 'react';
import ContentPage from '../components/ContentPage';
import {
  termsAndConditionsBody,
  termsAndConditionsTitle,
} from '../content/termsAndConditionsContent';

function TermsAndConditions() {
  return (
    <ContentPage
      title={termsAndConditionsTitle}
      body={termsAndConditionsBody}
    />
  );
}

export default TermsAndConditions;
